<bmcore-cookie-policy-popup [colorSettingsMode]="colorSettingsMode"> </bmcore-cookie-policy-popup>
